import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Grid,
  Divider,
  useTheme,
  Dialog,
  DialogContent,
} from '@mui/material';

const OrganizationVerification = ({ formData, initialData, onBack, lenderId, userId, preventClose, onVerificationSuccess }) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (preventClose) {
      const handleBeforeUnload = (e) => {
        e.preventDefault();
        e.returnValue = '';
        localStorage.clear();
      };

      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }
  }, [preventClose]);

  const handleClose = () => {
    localStorage.removeItem('tempJwtToken');
    localStorage.removeItem('tempUuid');
    
    if (onBack) {
      onBack();
    } else {
      setIsOpen(false);
      if (onVerificationSuccess) {
        onVerificationSuccess();
      }
    }
  };

  const content = (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" gutterBottom color="primary" sx={{ mb: 3 }}>
        Organisation Verification Process
      </Typography>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 4 }}>
        To verify your organisation after submitting the initial page, you will receive unique identification numbers.
      </Typography>

      <Box sx={{ 
        mb: 4, 
        p: 3, 
        bgcolor: 'rgba(0, 74, 173, 0.03)', 
        borderRadius: 2,
        border: '1px solid rgba(0, 74, 173, 0.1)'
      }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box>
              <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 1 }}>
                Lender ID
              </Typography>
              <Typography variant="h6" sx={{ 
                color: '#004AAD', 
                fontWeight: 'bold',
                p: 1.5,
                bgcolor: 'white',
                borderRadius: 1,
                border: '1px solid rgba(0, 74, 173, 0.2)',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
              }}>
                {lenderId}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ mb: 4 }}>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Send an email to verify <span style={{ color: '#004AAD', fontWeight: 'bold' }}>@contact@dequitec.com</span> with your Lender ID as the subject line.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Ensure the email is sent from your official email address for faster verification.
        </Typography>
      </Box>

      <Box sx={{ 
        p: 3, 
        bgcolor: '#F8F9FA', 
        borderRadius: 2,
        border: '1px solid rgba(0, 0, 0, 0.05)',
        mb: 4
      }}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
          Important Notes:
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          • Keep your Lender ID safe for future reference
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          • You will need this ID for any support requests
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
        <Button
          variant="contained"
          onClick={handleClose}
          sx={{
            backgroundColor: "#003A91",
            "&:hover": { backgroundColor: "#002570" },
            height: "40px",
            textTransform: "none"
          }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown={preventClose}
    >
      <DialogContent>
        {content}
      </DialogContent>
    </Dialog>
  );
};

export default OrganizationVerification; 